import React from "react";
import {
  InputLabel,
  Divider,
  Typography,
  Button,
  Grid,
  TextField,
} from "@common-ui/ui";
import { useDispatch, useSelector } from "react-redux";
import { procedureSlice } from "../../../../reducers/procedureReducer";

const Custom = ({
  sectionItem,
  sectionId,
  sectionItemIndex,
  sectionStep,
  step,
  handleRemoveSectionItem,
  subSectionStep,
  subSectionId,
}) => {
  const section = useSelector((state) =>
    state.procedure.items.find((section) => section.id === sectionId)
  );
  let subSection;
  if (subSectionId) {
    subSection = section.items.find((section) => section.id === subSectionId);
  }
  const getStep = (id) => {
    if (subSection) {
      return `${subSectionStep}.${
        Array.from(subSection.steps).indexOf(id) + 1
      }`;
    }
    return Array.from(section.steps).indexOf(id) + 1;
  };
  const dispatch = useDispatch();
  const handleDeleteItem = () => {
    dispatch(
      procedureSlice.actions.deleteItem({
        sectionId,
        sectionItemId: sectionItem.id,
        subSectionId,
        type: sectionItem.type,
      })
    );
  };
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Step</InputLabel>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <InputLabel fontWeight="700">Label</InputLabel>
          </div>
        </Grid>
        <Grid item md={4} xs={12}>
          <div>
            <InputLabel fontWeight="700">App URL</InputLabel>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <InputLabel fontWeight="700">Configuration</InputLabel>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel fontWeight="700">Actions</InputLabel>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item md={1} xs={12}>
          <div>
            <Typography
              fontWeight="700"
              sx={{ mt: { md: 1.5 } }}
            >{`${sectionStep}.${getStep(sectionItem.id)}`}</Typography>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <TextField
              sx={{ mt: 1 }}
              onChange={(e) =>
                dispatch(
                  procedureSlice.actions.updateSectionItems({
                    sectionId,
                    sectionItemId: sectionItem.id,
                    type: sectionItem.type,
                    name: e.target.name,
                    value: e.target.value,
                    subSectionId,
                  })
                )
              }
              size="small"
              fullWidth
              name="label"
              value={sectionItem.label}
              variant="outlined"
              placeholder="Example: Self Test"
            />
          </div>
        </Grid>
        <Grid item md={4} xs={12}>
          <div>
            <TextField
              sx={{ mt: 1 }}
              onChange={(e) =>
                dispatch(
                  procedureSlice.actions.updateSectionItems({
                    sectionId,
                    sectionItemId: sectionItem.id,
                    type: sectionItem.type,
                    name: e.target.name,
                    value: e.target.value,
                    subSectionId,
                  })
                )
              }
              size="small"
              fullWidth
              placeholder="Example: https://wwww.example.com"
              name="url"
              value={sectionItem.url}
              variant="outlined"
            />
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <TextField
              sx={{ mt: 1 }}
              onChange={(e) =>
                dispatch(
                  procedureSlice.actions.updateSectionItems({
                    sectionId,
                    sectionItemId: sectionItem.id,
                    type: sectionItem.type,
                    name: e.target.name,
                    value: e.target.value,
                    subSectionId,
                  })
                )
              }
              size="small"
              fullWidth
              placeholder="Example: config"
              name="configuration"
              value={sectionItem.configuration}
              variant="outlined"
            />
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <Button
              // startIcon={<DeleteForever />}
              sx={{ fontWeight: 200, mt: { md: 1.5 } }}
              size="small"
              onClick={() => handleDeleteItem()}
            >
              Remove
            </Button>
          </div>
        </Grid>
      </Grid>

      {/* <div>Coming Soon!</div>  */}
      <Divider sx={{ my: 2 }} />
    </div>
  );
};

export default Custom;
